import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { parse } from 'libphonenumber-js';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';

/*
  Generated class for the SmsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SmsProvider {

  constructor(public http: HttpClient, private toast: ToastAlertsProvider, private client: ClientDetailsProvider) {
    //console.log('Hello SmsProvider Provider');
  }

  sendSMSForBrowser(contacts,msg) {
    if(contacts && contacts.length > 0){
      let phones = [];

      contacts.forEach(contact => {
        phones.push(contact.tel);
      });

      let response = this.sendNotification(msg, phones);
      console.log('notification resp', response);
      return response;
    }
  }

  sendNotification(message, phones) {
    /*
    return new Promise(resolve => {
      this.client.load().then((client)=>{
        params.client = client.keyword;
        this.http.post(`https://api.communico.co/v2/${params.client}/notifications/email/`, JSON.stringify(params))
          .subscribe(result => {
            console.log('api resp', result);
            return result;
          });
      });
    });

    */
   //console.log('snp', params);
   var fd = new FormData();
   fd.append('client_id', 'ioIovGsua94zG9iWPw5X');
   fd.append('client_secret', 'SlgiT3NH0thcnZBxdMu5');
   fd.append('grant_type', 'client_credentials');

   var textFD = new FormData();
    this.client.load().then((client)=>{
      fetch(`http://api.communico.co/v3/token`, {
          method: 'POST',
          body:  fd
      })
      .then(res => {
        let resp = res.json();
        resp.then((apiToken) => {
          let token = apiToken.access_token;
          //params.token = token;
          //this.sendWithAuth(params).then((data)=>{
          //  console.log('swa', data);
          //});
          var textResp = [];
          phones.forEach((phone)=>{
            textFD.set('to', phone);
            textFD.set('body', message);

            fetch(`http://api.communico.co/v2/cuyahogademo/notifications/text`, {
              method: 'POST',
              body:  textFD,
              headers: {
                'Authorization': 'Bearer ' + token
              }
            })
            .then(res => {
              textResp.push(res.json());
            });
          });
        });
      });
    });
  }

  triggerToast(msg) {
    this.toast.triggerToast(msg, '');
  }
}



// WEBPACK FOOTER //
// ./src/providers/sms/sms.ts